import { Button, Form, Input, message, Modal, Radio } from 'antd';
import * as React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { fetchTrackingData } from 'src/actions/shipmentExecutionActions';
import ApiDto from 'src/dto/ApiDto';
import { addTracking } from 'src/api/shipmentExecution';
import { SHIPMENT_TYPE } from 'src/components/pages/Container/ContainerUtils';
import Select from 'antd/lib/select';
import { stops, validatePositiveInt } from 'src/Library/Helper';
import FailureArrayHandler from 'src/components/common/FailureArrayHandler';
import { interactive } from 'src/design-system/mixins';
import BulkTrackingErrorModal from './BulkTrackingErrorModal';

const FormItem = Form.Item;

const styles = theme => ({
  form: {
    '& .ant-form-item': {
      width: '100% !important',
    },
    ...interactive.antFormRequiredHide,
    '& .ant-form-item-label': {
      lineHeight: '26px',
    },
    '& .ant-form-explain': {
      fontSize: '12px',
      left: '12px',
      position: 'absolute',
    },
  },
  hintHeader: {
    fontSize: theme.fontSize.caption,
    fontWeight: theme.fontWeight.semibold,
    color: '#262626',
    textAlign: 'left',
    paddingTop: '6px',
  },
  required: {
    color: '#EB2727',
  },
});

class SEAddTrackingModal extends React.PureComponent<any, any> {

  state: any = {
    isSaving: false,
    callApi: undefined,
    formblNumber: [],
    formContainerNumber: [],
    formHblNumber: [],
    submitReady: false,
    errorMessages: {
      status: null,
    },
    status: null,
    failureArray: [],
    isErrorModalVisible: false,
  };

  hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);

  handleResponse = async (response) => {
    const { data: { referenceNumber }, form } = this.props;
    const trackingType = form.getFieldValue('trackingType');
    const containerNumber = this.state.formContainerNumber;
    const blNumber = this.state.formblNumber;
    const hblNumber = this.state.formHblNumber;
    const isContainer = trackingType === SHIPMENT_TYPE.CONTAINER;
    let entity ="";
    if (trackingType === SHIPMENT_TYPE.CONTAINER){
      entity = `Container ${containerNumber}`;
    }
    else if (trackingType === SHIPMENT_TYPE.HBL)
    {
      entity = `HBL ${hblNumber}`;
    }
    else {
      entity = `BL ${blNumber}`;
    }
    if (response.isSuccess) {
        if (!response?.data?.failureCount) {
          this.props.onClose(true);
        }
        if (response.data.successCount)
          message.success(`${response.data.successCount} ${trackingType} successfully added to shipment ${referenceNumber}`);
        /**
         * TODO: Instead of updating reducer state from here, we must instead let the parent refresh.
         * shipment cards are already refreshing, thanks to onClose(success = true),
         * same can be done with container cards in SETrackingCardsList.
         * Then perhaps this won't be needed.
         * Any other impact to be checked before doing this.
         */
        if (this.props.fromContainer) {
          await this.props.fetchTrackingData(referenceNumber);
        } else {
          await this.props.fetchTrackingData(referenceNumber, true);
        }
    } else {
      message.error(response.errorMessage);
    }
  }

  canAddTracking = (err) => {
    const { data } = this.props;
    const {formblNumber} = this.state;
    const {formContainerNumber} = this.state;
    const {formHblNumber} = this.state;
    if (err) {
      message.error(err);
      return false;
    }
    if (!data) {
      message.error('Error in fetching data , try again');
      return false;
    }
    if (!data.carrierCode) {
      message.error('Please update the Shipping Line in Shipment Details before adding BL/Containers');
      return false;
    }
    if (!data.referenceNumber) {
      message.error('Error fetching execution reference number , please try again ');
      return false;
    }
    return true;
  }

  createApiCallObject = (formData) : typeof ApiDto.AddTrackingInExecution => {
      const { data, shipmentId } = this.props;
      const trackingType = formData.trackingType;
      const movementType = 'EXPORT';
      const shippingLine = data.carrierCode;
      const executionReferenceNo = data.referenceNumber;
      const containerNumber : string[] = this.state.formContainerNumber;
      const blNumber : string[] = this.state.formblNumber;
      const hblNumber : string[] = this.state.formHblNumber;
      const entityNumber = {
        movementType,
        shippingLine,
        executionReferenceNo,
      };
      const entityNumberHBL = {
        trackingType,
        movementType,
        shippingLine,
        executionReferenceNo,
      }
      const apiCallObject: typeof ApiDto.AddTrackingInExecution = { shipmentId };
      const isTrackingTypeContainer = formData.trackingType === SHIPMENT_TYPE.CONTAINER;
      const isTrackingTypeBL = formData.trackingType === SHIPMENT_TYPE.BL;
      const isTrackingTypeBK = formData.trackingType === SHIPMENT_TYPE.BK;
      if (isTrackingTypeContainer) {
        apiCallObject.containerNumberList = [];
        for (let i=0; i< containerNumber.length; i++){
          apiCallObject.containerNumberList?.push({ ...entityNumber, containerNumber : containerNumber[i] });
        }
      }
      else if (isTrackingTypeBL){
        apiCallObject.blNumberList = [];
        for (let i=0; i< blNumber.length; i++){
          apiCallObject.blNumberList?.push({ ...entityNumber, blNumber : blNumber[i] });
        }
      } 
      else if (isTrackingTypeBK) {
        apiCallObject.bookingNumberList = [];
        for (let i=0; i< blNumber.length; i++){
          apiCallObject.bookingNumberList?.push({ ...entityNumber, bookingNumber : blNumber[i] });
        }
      }
      else {
        apiCallObject.blNumberList = [];
        for (let i=0; i< blNumber.length; i++){
          apiCallObject.blNumberList?.push({ ...entityNumberHBL, hblNumber : hblNumber[i] });
        }
      }
      return apiCallObject;
  }

  /**
   * Api call object needs form data, but it's only available as long as the form is visible.
   * (Note: Sometimes (weirdly) available even after it's hidden but not after a few seconds.)
   * To re-use the same data, we are creating an api caller and saving it in the state while the form is visible.
   * This api caller can then be used even in the absence of the form data.
   * Google 'higher order function (that returns a function)' if still in confusion.
   */
  getApiCaller = apiCallObject => async () => {
    const { status, errorMessages, isErrorModalVisible, failureArray } = this.state;
    this.setState({ isSaving: true });
    const response = await addTracking({
      ...apiCallObject,
    });
    const {isVisible} = this.props;
    this.setState({ isSaving: false });
    if (response?.data?.failureCount)
    {
      this.setState({
        isErrorModalVisible: true,
        failureArray: response.data.failureArray,
      });
    }
    this.handleResponse(response);
    }

  handleAddTracking = async () => {
    const { form } = this.props;
    form.validateFields(async (err, values) => {
      if (!this.canAddTracking(err)) {
        return;
      }
      const apiCallObject = this.createApiCallObject(values);
      this.setState({
        callApi: this.getApiCaller(apiCallObject),
      }, async () => {
        await this.state.callApi();
      });
    });
  }
  
  handleChange = (value)=>{
    this.setState({
      formblNumber: value,
      formContainerNumber: value,
      formHblNumber: value,
    });
    if (value){
      this.setState({submitReady: true});
    }
    else {
      this.setState({submitReady: false});
    }
  }

  onClose = () => {
    this.setState({ 
      isErrorModalVisible: false,
    });
    this.props.onClose(true);
  }

  render() {
    const { classes, isVisible } = this.props;
    const { isSaving, confirmModalVisible } = this.state;
    const { getFieldDecorator, getFieldsError, getFieldValue } = this.props.form;
    const { errorMessages, status, failureArray, isErrorModalVisible } = this.state;
    return (<>
      <Modal title={'Add Tracking'}
        centered
        visible={isVisible} width={505} okText="Submit"
        onCancel={() => this.props.onClose()}
        destroyOnClose
        onOk={() => this.handleAddTracking()}
        footer={[
          <Button key="back" onClick={() => this.props.onClose()}> Cancel</Button>,
          <Button loading={isSaving}
            key="confirm" type="primary" onClick={() => this.handleAddTracking()}
            > Submit</Button>,
        ]}
        // zIndex={1060}
        confirmLoading={false}
      >
          <Form layout="inline" className={classes.form} style={{textAlign: 'center'}}>
            <FormItem>
              {
                getFieldDecorator('trackingType', {
                  initialValue: SHIPMENT_TYPE.BL,
                  rules: [{ required: true }],
                })(
                  <Radio.Group  style={{ marginBottom: 10 }}>
                    <Radio.Button style={{ width: '100px', textAlign: 'center' }}
                     value={SHIPMENT_TYPE.BL}>
                      BL
                    </Radio.Button>
                    <Radio.Button style={{ width: '100px', textAlign: 'center' }}
                     value={SHIPMENT_TYPE.BK}>
                      BK
                    </Radio.Button>
                    <Radio.Button style={{ width: '100px', textAlign: 'center' }}
                     value={SHIPMENT_TYPE.CONTAINER}>
                      Container
                    </Radio.Button>
                    <Radio.Button style={{ width: '100px', textAlign: 'center' }}
                     value={SHIPMENT_TYPE.HBL}>
                      HBL
                    </Radio.Button>
                  </Radio.Group>,
                )
              }
            </FormItem>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '60px', textAlign: 'center', marginTop: '5px' }}>
              { (()=>{
                if (getFieldValue('trackingType') === SHIPMENT_TYPE.BL){
                  return (
                    <FormItem colon={false}
                  label={<div className={classes.hintHeader}>BL Number <span
                    className={classes.required}>*</span></div>}>
                  {getFieldDecorator('blNumber' , {
                    initialValue: [],
                    rules: [{ required: true, message: 'BL Number is required' },
                    {
                      validator: (rule, value, callback) => {
                        value?.forEach((item) => {
                          if (item.length && item.match(/[^a-zA-Z0-9]/)) {
                            return callback(' Should be alphanumeric');
                          }
                          if (item.length > 25) {
                            return callback('Max length of 25 exceeded');
                          }
                        });
                        return callback();
                      },
                    }],
                  })(
                      <Select
                      style={{
                        overflow: 'hidden',
                        marginLeft: '10px', 
                        width: '170px' 
                      }}
                      mode="tags"
                      maxTagCount={2}  
                      placeholder={"BL Number"}
                      className={classes.input}
                      onChange={this.handleChange}
                      notFoundContent={null}
                    />
                  )}
                </FormItem>
                  )
                }
                else if (getFieldValue('trackingType') === SHIPMENT_TYPE.BK) {
                  return (
                    <FormItem colon={false}
                  label={<div className={classes.hintHeader}>Booking Number <span
                    className={classes.required}>*</span></div>}>
                  {getFieldDecorator('bookingNumber' , {
                    initialValue: [],
                    rules: [{ required: true, message: 'Booking Number is required' },
                    {
                      validator: (rule, value, callback) => {
                        value?.forEach((item) => {
                          if (item.length && item.match(/[^a-zA-Z0-9]/)) {
                            return callback(' Should be alphanumeric');
                          }
                          if (item.length > 25) {
                            return callback('Max length of 25 exceeded');
                          }
                        });
                        return callback();
                      },
                    }],
                  })(
                      <Select
                      style={{
                        overflow: 'hidden',
                        marginLeft: '10px', 
                        width: '170px' 
                      }}
                      mode="tags"
                      maxTagCount={2}  
                      placeholder={"Booking Number"}
                      className={classes.input}
                      onChange={this.handleChange}
                      notFoundContent={null}
                    />
                  )}
                </FormItem>
                  )
                }
                else if (getFieldValue('trackingType') === SHIPMENT_TYPE.CONTAINER){
                  return (
                    <FormItem colon={false}
                  label={<div className={classes.hintHeader}>Container Number <span
                    className={classes.required}>
                    *</span></div>}>
                  {getFieldDecorator('containerNumber' , {
                    initialValue: [],
                    rules: [{ required: true, message: 'Container Number is required' },
                    {
                      validator: (rule, value, callback) => {
                        value?.forEach((item) => {
                          if (item.length && item.match(/[^a-zA-Z0-9]/)) {
                            return callback(' Should be alphanumeric');
                          }
                          if (item.length > 25) {
                            return callback('Max length of 25 exceeded');
                          }
                        });
                        return callback();
                      },
                    }],
                  })
                  (
                      <Select
                      style={{
                        overflow: 'hidden',
                        marginLeft: '10px', 
                        width: '170px'
                      }}
                      mode="tags"
                      maxTagCount={2}
                      placeholder={"Container Number"}
                      className={classes.input}
                      onChange={this.handleChange}
                      notFoundContent={null}
                    />
                  )}
                </FormItem>
                  )
                }
                else {
                  return (
                    <FormItem colon={false}
                  label={<div className={classes.hintHeader}>HBL Number <span
                    className={classes.required}>
                    *</span></div>}>
                  {getFieldDecorator('hblNumber' , {
                    initialValue: [],
                    rules: [{ required: true, message: 'HBL Number required' },
                    {
                      validator: (rule, value, callback) => {
                        value?.forEach((item) => {
                          if (item.length && item.match(/[^a-zA-Z0-9]/)) {
                            return callback(' Should be alphanumeric');
                          }
                          if (item.length > 25) {
                            return callback('Max length of 25 exceeded');
                          }
                        });
                        return callback();
                      },
                    }],
                  })(
                      <Select
                      style={{
                        overflow: 'hidden',
                        marginLeft: '10px', 
                        width: '170px'
                      }}
                      mode="tags"
                      maxTagCount={2}
                      placeholder={"HBL Number"}
                      className={classes.input}
                      onChange={this.handleChange}
                      notFoundContent={null}
                    />
                  )}
                </FormItem>
                  )
                }
              })() }
            </div>
          </Form>
        {
          this.state.isErrorModalVisible && 
          <BulkTrackingErrorModal
        id={'line item id'}
        failureArray={failureArray}
        isVisible={this.state.isErrorModalVisible}
        onModalClose={this.onClose} >
        </BulkTrackingErrorModal>}
      </Modal>
    </>);
  }

}

const mapDispatchToProps = (dispatch, ownProps) => (bindActionCreators({
  fetchTrackingData,
}, dispatch));

const SEAddTrackingModalStyled = withStyles(styles)(Form.create()(SEAddTrackingModal));
export default withRouter(connect(null, mapDispatchToProps)(SEAddTrackingModalStyled));
